const CardPreview = require('../ui/card-preview');
const Stats = require('../../lib/util/math/stats');
const template = require('./sample-draw.tpl').default;

module.exports = DomClass(template, function SampleDraw() {
	var _t = this;

	var allCards = [];
	this.cards = [];
	this.lastNewHandSize = 7;

	this.drawNewHand = function(count) {
		count = count || 7;
		this.lastNewHandSize = count;
		this.cards = Stats.shuffle(allCards);
		this.hand = this.cards.splice(0, count);
	};

	this.drawOne = function() {
		this.hand.push(this.cards.shift());
	};

	this.drawMulligan = function() {
		this.drawNewHand(
			Math.max((this.lastNewHandSize || 7) - 1, 1)
		);
	};

	this.importCards = function(cards) {
		this.hand = [];
		this.lastNewHandSize = 7;
		allCards = cards.reduce(function(individualCards, cardInfo) {
			for (var i = 0; i < cardInfo.activeQuantity; i++) {
				var details = {
					name: cardInfo.name,
					image: cardInfo.image,
					text: cardInfo.text,
					type: cardInfo.type,
					manaCost: cardInfo.manaCost,
					power: cardInfo.power,
					toughness: cardInfo.toughness
				};
				individualCards.push(new CardPreview(details));
			}
			return individualCards;
		}, []);

		if (allCards.length == 0) {
			this.classList.add('empty');
			return;
		}

		this.classList.remove('empty');
		this.drawNewHand();
	};

	this.__dom.newHand.onclick = function() {
		_t.drawNewHand();
	};

	this.__dom.mulligan.onclick = function() {
		_t.drawMulligan();
	};

	this.__dom.draw.onclick = function() {
		_t.drawOne();
	};

	this.__dom.newHand_bottom.onclick = function() {
		_t.drawNewHand();
	};

	this.__dom.mulligan_bottom.onclick = function() {
		_t.drawMulligan();
	};

	this.__dom.draw_bottom.onclick = function() {
		_t.drawOne();
	};

});
